// extracted by css-extract-rspack-plugin
export default {"sdkAppIdInfoAlert":"yvwWbCRr6lsdNZNR"};